import { useEffect, useState } from 'react';
import './index.less';
import { graphicStore } from '@/global/store/graphic-store';
import { Sensor } from '@/global/interface/device/sensor';
import { useParams } from 'react-router-dom';
import { getProjectSensors } from '@/api/project-device/project-sensor';
import { getSensors } from '@/api/device/sensor';
import classNames from 'classnames';


interface IProps {
    onChangeShowDevice: (show: boolean) => void;
}

export default function DeviceListPanel(props: IProps) {
    const { projectId } = useParams();

    const [entities, setEntities] = useState<any[]>([]);    // 所有的设备
    const [sensors, setSensors] = useState<Sensor[]>([]);    // 所有的传感器
    const [activeUuid, setActiveUuid] = useState<string>('');    // 当前选中的设备

    // 点击设备
    const onClickDevice = (device: any) => {
        const editor = graphicStore?.extraContext?.getCurrentViewEditor();
        if (editor.entityDict[device?.uuid] && editor.entityDict[device?.uuid].isSelected) return;
        editor.entityDict[device?.uuid].isSelected = true;
        editor.selectControl.forceEntitiesSelected([editor.entityDict[device?.uuid]]);
        editor.listeners.signals.needRender.dispatch('redraw');
        props.onChangeShowDevice(false);
    }

    useEffect(() => {
        if (!+projectId) return;
        getSensors(+projectId).then(res => {
            const sensors = res.data || [];
            setSensors(sensors);
        })
    }, [projectId])

    useEffect(() => {
        if (!graphicStore?.extraContext?.getCurrentViewEditor() || !sensors || sensors.length == 0) return () => { }

        const editor = graphicStore?.extraContext?.getCurrentViewEditor();
        editor.listeners.signals.emptySelectedEntities.dispatch();

        const entityDict = editor?.entityDict || {};
        let entities = [];
        for (let sensor of sensors) {
            const primitiveUuid = sensor?.primitiveUuid;
            if (!primitiveUuid) continue;
            const entity = entityDict[primitiveUuid];
            if (!entity) continue;
            const newEntity = { ...entity, sensor: sensor };
            entities.push({ ...newEntity });
        }
        setEntities(entities);

    }, [graphicStore?.extraContext?.getCurrentViewEditor(), sensors])

    return <div className='device-list-panel'>
        {entities?.map(entity => {
            return <div className={classNames({
                'device-item': true,
                'active': activeUuid == entity?.uuid
            })} key={`${entity?.uuid}-device-item`} onClick={() => onClickDevice(entity)}>
                {entity?.sensor?.code || "-"}
            </div>
        })}
    </div>
}